const hisenseCategoryInputs = {
  Televisions: '2-42561424/reg_tv_model',
  Projectors: '2-42561424/reg_projector_model',
  Audio: '2-42561424/reg_audio_model',
  'Air Products': '2-42561424/reg_air_product_model',
  Refrigerators: '2-42561424/reg_refrigerator_model',
  Dishwashers: '2-42561424/reg_dishwasher_models',
  'Microwave Ovens': '2-42561424/reg_microwave_model',
  'Cooking Ranges': '2-42561424/reg_cooking_range_model',
  'Kitchen Packages': '2-42561424/reg_kitchen_package',
};

module.exports = {
  hisenseCategoryInputs,
};
